import React, { useEffect } from "react";
import SpriteSheet from "./Components/Common/Component/SpriteSheet";
import Routers from "./Route";
import CustomizerProvider from "./_helper/Customizer/CustomizerProvider";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import { ConfirmDialogProvider } from "./Components/Credora/Common/ConfirmDialogContext";
import { SendMessageProvider } from "./Components/Credora/Communications/SendMessageContext";
import CredoraToastContainer from "./Components/Credora/Common/CredoraToastContainer";
import SessionLockProvider from "./Components/Credora/Auth/SessionLockProvider";
import { getStoredUser } from "./api/auth";
import { applyStoredThemeBodyClasses, hydrateThemeFromUser } from "./utils/themePreferences";

const App = () => {
  useEffect(() => {
    const user = getStoredUser();
    if (user) {
      hydrateThemeFromUser(user);
    }
    applyStoredThemeBodyClasses();
  }, []);

  return (
  <>
    <SpriteSheet />
    <CredoraToastContainer />
    <CustomizerProvider>
      <AnimationThemeProvider>
        <ConfirmDialogProvider>
          <SendMessageProvider>
            <SessionLockProvider>
              <Routers />
            </SessionLockProvider>
          </SendMessageProvider>
        </ConfirmDialogProvider>
      </AnimationThemeProvider>
    </CustomizerProvider>
  </>
  );
};

export default App;
